import Signer from 'sign-assistant-extension'
import { debugLog, sessionLogs } from '@/services/logs'
import { toast } from '@/hooks/useToast'
import { sendIsolatedErrorMessageSlackNotification } from '@/services/notifier'
import SignAssistantErrorToastAction from './SignerError'

export const signer = new Signer({
  id: 'ledger',
  key: '',
  logs: true,
  downloadLinks: {
    firefox: 'https://addons.mozilla.org/pt-BR/firefox/addon/ledger-sign/',
    chrome:
      'https://chrome.google.com/webstore/detail/ledgersign/igchjejidglijjooolpflbjmllichock?hl=pt-BR',
  },
  // onRequest: (request) => {},
  onResponse: (response, request) => {
    // Removing certificate PEM from logs
    const cleanResponse = (() => {
      const responseCopy = JSON.parse(JSON.stringify(response))
      if (responseCopy.message && responseCopy.message.length > 0) {
        responseCopy.message = responseCopy.message.map((el: any) => {
          if (typeof el === 'object' && el.pem) {
            el.pem = '*'
            return el
          }
          return el
        })
      }

      return responseCopy
    })()
    debugLog({ response: cleanResponse, request }, 'cli response')
  },
  onRequest: (request) => {
    debugLog(request, 'cli request')
  },
  onError: (error) => {
    const handledNotInstalledSoftware = `EXTENSION_RUNTIME_5`
    const handledExtensionNotInstalled = `LIB_1`
    const handledErrors = [
      handledNotInstalledSoftware,
      handledExtensionNotInstalled,
    ]
    const currentError = `${error.level}_${error.code}`
    const isHandledError = handledErrors.includes(currentError)
    if (isHandledError) return

    const expectedErrorWrongPass = `CLI_7`
    const expectedErrorCanceled = `CLI_9`

    const expectedErrors = [expectedErrorWrongPass, expectedErrorCanceled]
    const isExpectedError = expectedErrors.includes(currentError)

    toast({
      title: error.error,
      variant: 'destructive',
      action: isExpectedError ? undefined : <SignAssistantErrorToastAction />,
    })
  },
})
